<template>
  <div v-if="!loading">
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:delete="isConfirm = !isConfirm"
      v-on:new="createHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import AppForm from "../../../components/payroll/monthlyepfsubmissionrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": AppForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('allepf.editmonthlyepfsubmissionrec'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
      dataItems: [],
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadStatutoryReport() {
      const vm = this;

      this.$store.dispatch('get', {url: "/epfsubmissionrecord/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];


          vm.pageTitleValue = res.data.rec[0].epfsubreccode;
          vm.formData.userid = this.$store.getters.userId;

          this.loadEpfSubRecPayout();

          // vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    //load tax sub rec payout
    loadEpfSubRecPayout() {
      const vm = this;

      this.$store.dispatch('get', {url: "/epfsubmissionrecordpy/" + this.id})
        .then((res) => {
          vm.formData.epfSelectedPayouts = res.data.rec;

          for (let i = 0; i < vm.formData.epfSelectedPayouts.length; i++) {
            Object.assign(vm.formData.epfSelectedPayouts[i], { action: 2 });
          }
          //console.log(" epfSPy", vm.formData.epfSelectedPayouts[0].poid)

          vm.loadEpfSubRecRef();

          //vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    //load tax sub rec ref
    loadEpfSubRecRef() {
      const vm = this;

      this.$store.dispatch('get', {url: "/epfsubmissionrecordref/" + this.id})
        .then((res) => {
          vm.formData.epfSubDetail = res.data.rec;

          console.log("taxsub detail", vm.formData.epfSubDetail);

          for (let i = 0; i < vm.formData.epfSubDetail.length; i++) {
            if (vm.formData.epfSubDetail[i].rcpdate) {
              vm.formData.epfSubDetail[i].rcpdate = moment(
                vm.formData.epfSubDetail[i].rcpdate
              ).format("YYYY-MM-DD");
            }

            // vm.formData.taxSubDetail[i].no = i + 1;
          }

          for (let i = 0; i < vm.formData.epfSubDetail.length; i++) {
            Object.assign(vm.formData.epfSubDetail[i], { action: 2 });
            Object.assign(vm.formData.epfSubDetail[i], { no: i + 1 });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      //update record
      this.$store.dispatch('put', {url: "/epfsubmissionrecord/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "monthlyepfsubmissionrecordlist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/epfsubmissionrecord/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "monthlyepfsubmissionrecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "monthlyepfsubmissionrecordlist" });
    },

    createHandler() {
      this.$router.push({ name: "monthlyepfsubmissionrecordnew" });
    },
  },

  mounted() {
    this.loadStatutoryReport();
  },
};
</script>